<template>
  <div id='app'>
    <nav class='navbar is-primary'>
      <div class='navbar-brand'>
        <router-link to='/' class='navbar-item'>
          {{ DefaulTitle }}
        </router-link>
      </div>
      <div class='navbar-menu is-active'>
        <div class='navbar-end'>
          <button class="flag-btn" @click="changeLocale('fr')"><country-flag country='fr' /></button>
          <button class="flag-btn" @click="changeLocale('en')"><country-flag country='gb' /></button>
          <div v-if='user' class='navbar-item has-dropdown is-hoverable'>
            <div class='navbar-link'>
              {{ user.name }}
            </div>

            <div class='navbar-dropdown'>
              <a class='navbar-item' @click.prevent='logout'> {{$t('default.logout')}} </a>
              <a class='navbar-item' @click.prevent='downloadUserGuide'> {{$t('default.userguide')}} </a>
            </div>
          </div>
        </div>
      </div>
    </nav>

    <div class='main'>
      <router-view />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Vue from 'vue'

import CountryFlag from 'vue-country-flag'

Vue.component('country-flag', CountryFlag)

export default {
  data () {
    return {
      DefaulTitle: process.env.THEME === 'theme1' ? 'Groupe Casino Immobilier' : 'Dataroom Immo'
    }
  },
  computed: {
    ...mapState(['user']),
  },
  async created () {
    if (
      ['/', '/password', '/password-reset'].indexOf(this.$route.path) === -1
    ) {
      try {
        await this.$store.dispatch('getUser')
        if (!this.user) {
          throw new Error('Login required')
        }
      } catch (e) {
        console.log('e', e)
        this.$router.push('/')
      }
    }
  },
  methods: {
    logout () {
      this.$store.commit('inv/LOGOUT')
      this.$store.commit('LOGOUT')
      this.$router.push('/')
    },
    changeLocale (lng) {
      this.$i18n.locale = lng
    },
    async downloadUserGuide () {
      Vue.api.get('/static/userguide', { responseType: 'blob' })
        .then((response) => {
          const blob = new Blob([response], { type: 'application/pdf' })
          const link = document.createElement('a')
          link.href = URL.createObjectURL(blob)
          link.download = 'Guide utilisateur - Portail investisseurs - 16.07.2020.pdf'
          link.click()
          URL.revokeObjectURL(link.href)
        })
    },
  },
}
</script>

<style lang='scss' scoped>
.main {
  height: calc(100% - 52px);
}
.flag-btn{
  background: transparent;
  border: 0px;
}

</style>
